(function () {
  'use strict';

  // Aos Animation
  // ----------------------------------------
  AOS.init({
    once: true,
    disable: "mobile",
  });  

  // Smooth Scroll
  // ----------------------------------------
  SmoothScroll('a[href*="#"]', {
    speed: 600,
    topOnEmptyHash: false,
  });
})();
